import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({ label, field, name }) => {
  const [checked, setChecked] = useState(false);
  const s = require('./CheckButton.module.scss');

  return (
    <label className={s.CheckboxLabel} htmlFor={name}>
      <input
        type="checkbox"
        className={`${s.Checkbox}`}
        {...field}
        onChange={() => setChecked(!checked)}
      />{label && <span className={s.labelText} dangerouslySetInnerHTML={{ __html: label }} />}
    </label>
  );
}

Checkbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  field: PropTypes.object
};

export default Checkbox